let csjs = require('csjs');

export const noticeHeight = '110px';
export const noticeHeightHide = '115px';
export const toolbarHeight = '40px';
const notice = csjs`

	.notify-popup-wrapper {
		background: #FFF;
		position: fixed;
		width: 100%;
		top: -${noticeHeight};
		z-index: 10;
		text-align: center;
		padding: 15px 10px 10px 10px;
		box-sizing: border-box;
		box-shadow: 0 1px 3px rgba(0,0,0,0.2);
		height: ${noticeHeight};
	}
	.notify-popup-wrapper .notify-popup-title {
		font-size: 16px;
		color: #493f34;
		font-weight: bold;
	}
	.notify-popup-wrapper .notify-popup-desc {
		font-size: 13px;
		color: #81684d;
		line-height: 20px;
	}
	.notify-popup-wrapper .close-button {
		position: absolute;
		width: 20px;
		height: 20px;
		z-index: 21;
		top: 10px;
		right: 10px;
		cursor: pointer;
	}
	.notify-popup-wrapper .close-button:before, .notify-popup-wrapper .close-button:after {
		content: '';
		position: absolute;
		height: 2px;
		width: 100%;
		top: 50%;
		left: 0;
		margin-top: -1px;
		background: #cfc198;
	}
	.notify-popup-wrapper .close-button:before {
		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
	}
	.notify-popup-wrapper .close-button:after {
		-webkit-transform: rotate(-45deg);
		-moz-transform: rotate(-45deg);
		-ms-transform: rotate(-45deg);
		-o-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}
	.notify-popup-wrapper .close-button:hover:before, .notify-popup-wrapper .close-button:hover:after {
		background: #706150;
	}
	.notify-popup-wrapper .dekdbutton {
		padding: 7px 20px;
		height: 30px;
		text-shadow: none;
		font-size: 13px;
		border-bottom: none;
		border: solid 1px #de8022;
		margin-top: 5px;
		color: #fff;
    	text-decoration: none;
	}
	.notify-popup-wrapper .dekdbutton:active {
		border: solid 1px #de8022;
		box-shadow: none;
	}
	.notify-popup-more-container {
		text-align: center;
		padding: 5px;
	}
	.notify-popup-more {
		color: #cc6600;
		font-size: 11px;
	}
	.notify-popup-more:link {
		color: #cc6600;
		text-decoration: none;
	}
	
	.container {
		position: fixed;
		bottom: 0px;
		right: 0px;
		width: 300px;
		height: ${noticeHeight};
		background-color: red;
		z-index: 1000;
	}
	
	.show {
		top: ${toolbarHeight};
		display: block;
		visibility: visible;
	}
	
	.hide {
		top: -${noticeHeight};
	}
	
	.close {
		top: -${noticeHeight};
		animation-duration: 0.3s;
  		animation-name: slide-up;
	}
	
	
	
	@media only screen and (min-width: 768px)  {
		.notify-popup-wrapper {
			width: 320px;
			bottom: -${noticeHeightHide};
			right: 10px;
			top: inherit;
			box-shadow: 0 0px 7px rgba(0,0,0,0.4);
		}
		
		.show {
			bottom: 0;
			display: block;
			visibility: visible;
		}
		
		.hide {
			bottom: -${noticeHeight};
		}
		
		.close {
			bottom: -${noticeHeight};
			animation-duration: 0.3s;
			animation-name: slide-down;
		}
	}

	
	
	
	@keyframes slide-up {
		from {
			top: 0px;
		}
		
		to {
			top: -${noticeHeight};
		}
	}
	
	@keyframes slide-down {
		from {
			bottom: 0px;
		}
		
		to {
			bottom: -${noticeHeight};
		}
	}
	
`;

export default notice



/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/notice-style.cs.js
 **/